<button
  pButton
  [pTooltip]="tooltipContent"
  tooltipPosition="top"
  tooltipStyleClass="-mt-3"
  [rounded]="true"
  icon="fas fa-clipboard-list"
  (click)="openReportWindow()"></button>
<ng-template #tooltipContent>
  <div class="flex align-items-center">
    <span>
      <b>Vergleichsbericht:</b> Vergleichen Sie einen Teilraum oder Standort mit
      anderen – über alle Indikatoren hinweg.
    </span>
  </div>
</ng-template>
